/**
 * Styles pack opening — copie fidèle App.css (GDA Casino) avec palette App1.
 * Source: App.css
 */
const PACK_CSS = `

@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@500;700;800;900&display=swap');

/* Palette App1 — remplace var(--gold) etc. dans le scope pack */
.global-pack-view,
.pack-ov {
  --gold: #4a90e2;
  --gold2: #3b78c8;
  --gold3: #1e3c8c;
  --neon: #93c5fd;
  --neon2: #6ba3e8;
  --purple: #6ba3e8;
  --muted: rgba(191, 219, 254, 0.55);
  --text: #f4f8ff;
}

/* ── Fond SWISS3 (identique app — png + fill plein écran) ── */
.pack-swiss-bg{
  position:fixed;inset:0;z-index:0;overflow:hidden;pointer-events:none;
}
.pack-swiss-bg__img{
  position:absolute;inset:0;width:100%;height:100%;
  object-fit:fill;object-position:center;
  opacity:0.88;filter:saturate(1.12) brightness(0.96);
}
.pack-swiss-bg__veil{
  position:absolute;inset:0;
  background:
    radial-gradient(ellipse 90% 50% at 50% -8%, rgba(74,144,226,0.38) 0%, transparent 55%),
    linear-gradient(180deg,rgba(8,16,36,0.32) 0%,rgba(8,16,36,0.52) 100%);
  pointer-events:none;
}
.pack-swiss-bg--overlay .pack-swiss-bg__veil{
  background:
    radial-gradient(ellipse 90% 50% at 50% -8%, rgba(74,144,226,0.42) 0%, transparent 55%),
    linear-gradient(180deg,rgba(8,16,36,0.55) 0%,rgba(8,16,36,0.72) 100%);
}
.pack-ov .pack-swiss-bg{
  position:absolute;inset:0;z-index:0;
}

/* Alias vues App1 */
.global-pack-view {
  position:relative;z-index:1;
  min-height:100vh;min-height:100dvh;
  padding: 12px max(14px, env(safe-area-inset-left, 0px)) 108px max(14px, env(safe-area-inset-right, 0px));
  max-width: 520px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}
.global-pack-view--hidden{
  visibility:hidden !important;
  opacity:0 !important;
  pointer-events:none !important;
  position:fixed !important;
  inset:0;
  z-index:-1;
}

/* Boutons liquid glass — même langage que l’app */
.gs-pack-btn{
  display:inline-flex;align-items:center;justify-content:center;gap:8px;
  box-sizing:border-box;
  border-radius:16px;
  font-weight:800;
  color:#f0f9ff;
  cursor:pointer;
  -webkit-tap-highlight-color:transparent;
  backdrop-filter:blur(22px) saturate(220%);
  -webkit-backdrop-filter:blur(22px) saturate(220%);
  transition:transform 0.15s ease, filter 0.15s ease, opacity 0.15s ease;
}
.gs-pack-btn:active{transform:scale(0.97)}
.gs-pack-btn:disabled{opacity:0.5;cursor:not-allowed;filter:grayscale(0.25)}
.gs-pack-btn--back{
  width:auto;min-height:44px;padding:10px 14px;margin-bottom:14px;
  font-size:clamp(13px,3.5vw,15px);
  background:linear-gradient(135deg, rgba(74,144,226,0.28) 0%, rgba(30,60,140,0.42) 100%);
  border:1.5px solid rgba(147,197,253,0.4);
  box-shadow:0 4px 18px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.22);
}
.gs-pack-btn--primary{
  width:100%;
  max-width:100%;
  min-height:48px;
  padding:clamp(12px,3.2vw,15px) clamp(14px,4vw,20px);
  font-size:clamp(13px,3.6vw,15px);
  letter-spacing:0.04em;
  background:linear-gradient(135deg, rgba(74,144,226,0.55) 0%, rgba(30,80,180,0.72) 55%, rgba(10,40,120,0.78) 100%);
  border:1.5px solid rgba(147,197,253,0.55);
  box-shadow:0 8px 28px rgba(74,144,226,0.38), inset 0 1px 0 rgba(255,255,255,0.3);
}
.global-pack-hdr { text-align: center; padding: 14px 14px 10px; }
.global-pack-hdr h2 {
  font-family: 'Orbitron', monospace;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #fff 0%, #bfdbfe 40%, #4a90e2 72%, #1e3c8c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.global-pack-hdr p {
  font-size: 10px;
  color: var(--muted);
  margin-top: 4px;
  line-height: 1.45;
}
.global-pack-stage { display: flex; flex-direction: column; align-items: center; padding: 6px 16px 18px; perspective: 900px; overflow: visible; }
.global-pack-free-hint { text-align: center; font-size: 0.75rem; color: #93c5fd; margin-top: 8px; }
.global-pack-hero { text-align: center; padding: 8px 12px 4px; }
.global-pack-hero h2 {
  font-family: 'Orbitron', monospace;
  font-size: clamp(15px, 4.2vw, 18px);
  font-weight: 900;
  letter-spacing: 0.5px;
  margin: 0;
  background: linear-gradient(135deg, #fff 0%, #bfdbfe 40%, #4a90e2 72%, #1e3c8c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.global-pack-hero p {
  font-size: 11px;
  color: rgba(226, 232, 240, 0.72);
  margin: 6px auto 0;
  max-width: 320px;
  line-height: 1.45;
}
.global-pack-referral {
  position: relative;
  margin: 10px 4px 14px;
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(145deg, rgba(255,255,255,0.12) 0%, rgba(74,144,226,0.1) 42%, rgba(15,25,55,0.28) 100%);
  backdrop-filter: blur(22px) saturate(1.35);
  -webkit-backdrop-filter: blur(22px) saturate(1.35);
  border: 1px solid rgba(147, 197, 253, 0.32);
  box-shadow: 0 8px 36px rgba(0,0,0,0.28), 0 0 0 1px rgba(255,255,255,0.08) inset, 0 2px 0 rgba(255,255,255,0.14) inset;
}
.global-pack-referral--active {
  border-color: rgba(74, 222, 128, 0.45);
  box-shadow: 0 8px 36px rgba(34,197,94,0.18), 0 0 0 1px rgba(74,222,128,0.15) inset;
}
.global-pack-referral__shine {
  position: absolute; inset: 0; border-radius: inherit; pointer-events: none;
  background: linear-gradient(118deg, transparent 28%, rgba(255,255,255,0.16) 48%, transparent 68%);
  animation: packCreditShine 5s ease-in-out infinite;
}
.global-pack-referral__inner { position: relative; padding: 14px 16px 14px; }
.global-pack-referral__inner--compact { padding: 12px 14px 12px; }
.global-pack-referral__inner--compact .global-pack-referral__ttl { margin-bottom: 2px; }
.global-pack-referral__inner--compact .global-pack-referral__cta { margin-top: 10px; padding: 10px 12px; }
.global-pack-referral__row {
  display: flex; align-items: flex-start; gap: 12px;
}
.global-pack-referral__icon {
  flex-shrink: 0; width: 44px; height: 44px; border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(74,144,226,0.22);
  border: 1px solid rgba(147,197,253,0.35);
  box-shadow: 0 4px 16px rgba(74,144,226,0.25);
  font-size: 1.35rem; line-height: 1;
}
.global-pack-referral--active .global-pack-referral__icon {
  background: rgba(34,197,94,0.2);
  border-color: rgba(74,222,128,0.4);
}
.global-pack-referral__body { flex: 1; min-width: 0; text-align: left; }
.global-pack-referral__badge {
  display: inline-block; margin-bottom: 5px; padding: 2px 9px; border-radius: 999px;
  font-family: 'Orbitron', monospace; font-size: 8px; font-weight: 700; letter-spacing: 0.1em;
  color: #e0f2fe; background: rgba(74,144,226,0.35);
  border: 1px solid rgba(147,197,253,0.4);
  text-transform: uppercase;
}
.global-pack-referral--active .global-pack-referral__badge {
  color: #bbf7d0; background: rgba(34,197,94,0.28);
  border-color: rgba(74,222,128,0.45);
}
.global-pack-referral__ttl {
  font-family: 'Orbitron', monospace;
  font-size: clamp(11px, 3.2vw, 13px);
  font-weight: 700;
  color: #f8fafc;
  letter-spacing: 0.04em;
  line-height: 1.35;
  margin: 0 0 4px;
}
.global-pack-referral__sub {
  margin: 0;
  font-family: 'Rajdhani', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  color: rgba(226,232,240,0.82);
}
.global-pack-referral__steps {
  display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px;
}
.global-pack-referral__step {
  flex: 1 1 auto; min-width: 0;
  padding: 5px 8px; border-radius: 10px; text-align: center;
  font-family: 'Rajdhani', sans-serif; font-size: 10px; font-weight: 700;
  color: rgba(226,232,240,0.75);
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.1);
}
.global-pack-referral__step strong { display: block; font-size: 9px; letter-spacing: 0.06em; color: #93c5fd; margin-bottom: 2px; }
.global-pack-referral__cta {
  width: 100% !important;
  margin-top: 12px;
  font-family: inherit;
}
.global-pack-odds {
  background: linear-gradient(168deg, rgba(74, 144, 226, 0.14) 0%, rgba(10, 20, 60, 0.42) 100%);
  border: 1px solid rgba(107, 163, 232, 0.28);
  border-radius: 16px;
  padding: 12px 14px;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}
.global-pack-odds summary { cursor: pointer; font-weight: 700; font-size: 0.85rem; color: rgba(255, 255, 255, 0.92); list-style: none; }
.global-pack-odds summary::-webkit-details-marker { display: none; }

/* pack-open-btn — pleine largeur, responsive, style app */
.global-pack-view .pack-open-row {
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  padding: 0 0 8px;
  box-sizing: border-box;
}
.pack-open-btn.gs-pack-btn--primary,
.pack-open-btn {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  min-height: 48px;
  position: relative;
  overflow: hidden;
  font-family: inherit;
}
.pack-open-btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.22), transparent);
  animation: shine 7s infinite;
}
.pack-open-btn:active { transform: scale(0.97); }
.pack-open-btn:disabled { opacity: 0.45; cursor: not-allowed; filter: grayscale(0.35); }

/* @keyframes utilitaires */
@keyframes shine{0%{left:-100%}70%,100%{left:200%}}

/* Bouton ouverture (base cta + pack) */
.cta-btn{width:100%;padding:17px;border:none;border-radius:16px;background:linear-gradient(135deg, #93c5fd 0%, #4a90e2 35%, #3b78c8 100%);font-family:'Orbitron',monospace;font-size:14px;font-weight:700;color:#fff;letter-spacing:1px;cursor:pointer;position:relative;overflow:hidden;box-shadow:0 6px 32px rgba(158,112,40,0.5),inset 0 2px 0 rgba(255,255,255,0.35);border:1px solid rgba(228,208,175,0.55);transition:transform 0.15s,box-shadow 0.15s,filter 0.2s}
.cta-btn--casino{
  display:flex;flex-direction:row;align-items:center;justify-content:center;gap:12px;
  padding-left:16px;padding-right:16px;
}
.cta-btn__casino-lbl{position:relative;z-index:1;flex:0 1 auto;line-height:1.2;text-align:center}
.cta-btn__casino-logo{
  position:relative;z-index:1;width:clamp(28px,7.5vw,38px);height:clamp(28px,7.5vw,38px);
  object-fit:contain;flex-shrink:0;-webkit-user-drag:none;user-select:none;
  filter:drop-shadow(0 2px 10px rgba(0,0,0,0.35));
}
.cta-btn:active{transform:scale(0.97);box-shadow:0 3px 18px rgba(0,0,0,0.45),0 0 20px rgba(125,88,32,0.25)}
.cta-btn::after{content:'';position:absolute;top:0;left:-100%;width:100%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,0.22),transparent);animation:shine 7s infinite}
.cta-btn.pack-open-btn{
  width:100%;
  max-width:100%;
  min-width:0;
  min-height:48px;
  display:flex;
  align-items:center;
  justify-content:center;
  color:#fff;
}
.pack-open-btn-inner{
  display:inline-flex;align-items:center;justify-content:center;gap:10px;
  position:relative;z-index:1;
}
.pack-open-btn-inner--free{
  font-size:clamp(17px,5vw,20px);font-weight:900;letter-spacing:0.1em;
  color:#fff;
}
.pack-open-btn__num{
  font-family:'Orbitron',monospace;font-size:clamp(20px,6vw,26px);font-weight:900;letter-spacing:-0.02em;line-height:1;
  color:#fff;
  -webkit-text-fill-color:#fff;
}
.pack-open-btn-inner--ticket .pack-open-btn__num{
  color:#fff;
  -webkit-text-fill-color:#fff;
}
.coin-ic--packbtn{width:28px;height:28px;object-fit:contain;filter:drop-shadow(0 1px 2px rgba(0,0,0,0.2))}
.pack-open-btn__ticket-ic{width:28px;height:28px;object-fit:contain;filter:drop-shadow(0 1px 2px rgba(0,0,0,0.2));-webkit-user-drag:none;user-select:none}
.cta-btn.pack-open-btn:disabled{opacity:0.45;cursor:not-allowed;filter:grayscale(0.35)}

/* Pack — extrait App.css GDA */
/* ════════════════ PACK — carte TCG, accents or / ambre ════════════════ */
.pack-hdr{text-align:center;padding:14px 14px 10px}
.pack-hdr h2{font-family:'Orbitron',monospace;font-size:16px;font-weight:900;letter-spacing:0.5px;background:linear-gradient(135deg,#f0f9ff,#93c5fd 40%,var(--gold) 72%,#2a5099);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.pack-hdr p{font-size:10px;color:var(--muted);margin-top:4px;line-height:1.45}
.pack-stage-wrap{display:flex;flex-direction:column;align-items:center;padding:6px 16px 18px;perspective:900px;overflow:visible}
.pack-box-wrap{position:relative;width:min(234px,80vw);min-height:340px;height:auto;padding:0 0 12px;box-sizing:content-box;display:flex;align-items:center;justify-content:center;transform-style:preserve-3d;overflow:visible}
/* Carte preview : mouvement doux continu pour inviter à ouvrir */
.pack-box-float{animation:packIdleFloat 6.5s cubic-bezier(.42,0,.2,1) infinite;will-change:transform;transform:translateZ(0);backface-visibility:hidden}
@keyframes packIdleFloat{
  0%,100%{transform:translate3d(0,0,0) rotate(0deg) scale(1)}
  18%{transform:translate3d(3px,-8px,0) rotate(1.35deg) scale(1.012)}
  38%{transform:translate3d(-2px,-12px,0) rotate(-0.9deg) scale(1.016)}
  58%{transform:translate3d(-4px,-6px,0) rotate(-1.25deg) scale(1.01)}
  78%{transform:translate3d(2px,-3px,0) rotate(0.65deg) scale(1.006)}
}
@media (prefers-reduced-motion:reduce){
  .pack-box-float{animation:none}
}
.pack-box{position:relative;width:170px;height:258px;border-radius:14px;transform-style:preserve-3d;transition:transform 0.35s cubic-bezier(.22,1,.36,1),filter 0.45s cubic-bezier(.22,1,.36,1);cursor:pointer;filter:drop-shadow(0 16px 32px rgba(0,0,0,0.58))}
.pack-box.pack-booster,.pack-anim-box.pack-booster{
  --pack-lip-h:26px;
  --pack-lip-spread:4px;
}
.pack-box:hover{filter:drop-shadow(0 20px 42px rgba(0,0,0,0.68)) drop-shadow(0 0 26px rgba(74, 144, 226,0.38))}
.pack-box:active{transform:scale(0.97)}
.pack-booster{border-radius:6px}
.pack-face{position:absolute;inset:0;border-radius:14px;backface-visibility:hidden;overflow:hidden;border:1px solid rgba(107, 163, 232,0.35);box-shadow:inset 0 0 0 1px rgba(0,0,0,0.55)}
.pack-front{background:
  radial-gradient(ellipse 90% 55% at 50% 0%,rgba(74, 144, 226,0.09) 0%,transparent 52%),
  linear-gradient(180deg,#111018 0%,#14121c 45%,#0c0b10 100%);
  display:flex;flex-direction:column;align-items:center;justify-content:center;padding:18px 14px 16px;position:relative}
.pack-front::after{content:'';position:absolute;inset:8px;border-radius:9px;border:1px solid rgba(107, 163, 232,0.14);pointer-events:none;z-index:1}
/* Booster TCG — languettes foil haut/bas (vrai scellage), corps central violet */
.pack-booster .pack-face{border:none;border-radius:6px;box-shadow:none;overflow:hidden}
.pack-booster .pack-front::after{display:none}
.pack-booster .pack-front{
  border-radius:7px;
  padding:0;
  display:flex;
  flex-direction:column;
  align-items:stretch;
  justify-content:flex-start;
  isolation:isolate;
  background:#060504;
  box-shadow:
    inset 0 0 0 2px #080604,
    inset 0 0 0 4px rgba(74, 144, 226,0.22),
    0 18px 48px rgba(0,0,0,0.75);
}
.pack-crimps{
  flex-shrink:0;
  height:var(--pack-lip-h);
  align-self:stretch;
  margin-left:calc(-1 * var(--pack-lip-spread));
  margin-right:calc(-1 * var(--pack-lip-spread));
  width:calc(100% + 2 * var(--pack-lip-spread));
  box-sizing:border-box;
  position:relative;
  z-index:5;
  pointer-events:none;
  background-color:#0a0805;
  background-image:
    repeating-linear-gradient(90deg,
      #121018 0px,#121018 0.55px,
      #2a2418 0.55px,#2a2418 1.2px,
      #0c0a08 1.2px,#0c0a08 1.65px,
      #3a3020 1.65px,#3a3020 2.05px,
      #18120a 2.05px,#18120a 2.6px),
    linear-gradient(180deg,rgba(120,85,35,0.42) 0%,rgba(12,8,6,0.98) 48%,rgba(0,0,0,0.99) 100%);
  background-blend-mode:normal,normal;
  -webkit-mask-image:linear-gradient(90deg,transparent 0%,#000 14%,#000 86%,transparent 100%);
  mask-image:linear-gradient(90deg,transparent 0%,#000 14%,#000 86%,transparent 100%);
}
.pack-crimps--top{
  transform-style:preserve-3d;
  -webkit-transform-style:preserve-3d;
  border-bottom:1px solid rgba(0,0,0,0.88);
  box-shadow:
    inset 0 0 0 1px rgba(0,0,0,0.65),
    inset 0 -8px 18px rgba(0,0,0,0.68),
    inset 0 3px 6px rgba(255,235,255,0.1),
    inset 12px 0 24px rgba(100,65,28,0.16),
    inset -12px 0 24px rgba(0,0,0,0.35),
    0 5px 14px rgba(0,0,0,0.5);
}
.pack-crimps--top::after{
  content:'';
  position:absolute;
  left:10%;
  right:10%;
  bottom:0;
  height:1px;
  background:linear-gradient(90deg,transparent,rgba(255,215,255,0.28),transparent);
  pointer-events:none;
}
.pack-crimps--bottom{
  z-index:4;
  border-top:1px solid rgba(0,0,0,0.85);
  box-shadow:
    inset 0 0 0 1px rgba(0,0,0,0.6),
    inset 0 8px 18px rgba(0,0,0,0.62),
    inset 0 -3px 5px rgba(255,210,255,0.08),
    inset 12px 0 22px rgba(0,0,0,0.2),
    inset -12px 0 22px rgba(70,48,22,0.14),
    0 -5px 14px rgba(0,0,0,0.45);
}
.pack-crimps--bottom::before{
  content:'';
  position:absolute;
  left:10%;
  right:10%;
  top:0;
  height:1px;
  background:linear-gradient(90deg,transparent,rgba(255,200,255,0.12),transparent);
  pointer-events:none;
}
.pack-body-core{
  flex:1 1 auto;
  min-height:0;
  position:relative;
  z-index:2;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:10px 11px 12px;
  box-sizing:border-box;
  background:
    linear-gradient(92deg, rgba(255,255,255,0.32) 0%, rgba(255,220,180,0.1) 14%, transparent 32%),
    linear-gradient(100deg, transparent 0%, transparent 46%, rgba(0,0,0,0.42) 100%),
    linear-gradient(270deg, rgba(255,248,235,0.06) 0%, transparent 18%),
    radial-gradient(ellipse 92% 78% at 50% 45%, rgba(255,200,120,0.4) 0%, rgba(140,85,28,0.72) 24%, rgba(45,28,10,0.94) 50%, rgba(8,4,2,0.99) 76%, #030201 100%),
    linear-gradient(180deg,#1a3278 0%,#0f1d4a 38%,#080402 100%);
  box-shadow:
    inset 22px 0 48px rgba(255,230,200,0.08),
    inset -26px 0 54px rgba(0,0,0,0.5),
    inset 0 22px 50px rgba(255,180,100,0.06),
    inset 0 -28px 55px rgba(0,0,0,0.58);
}
.pack-body-core::after{
  content:'';
  position:absolute;
  inset:5px;
  border-radius:5px;
  border:1px solid rgba(107, 163, 232,0.14);
  pointer-events:none;
  z-index:0;
}
.pack-anim-box.pack-booster .pack-face{overflow:visible;perspective:600px;perspective-origin:50% 35%}
.pack-anim-box.phase-tear-top .pack-crimps--top{
  transform-origin:50% 100%;
  animation:packTopLipTear 0.86s cubic-bezier(.22,.82,.18,1) forwards;
  z-index:4;
  -webkit-mask-image:none;
  mask-image:none;
  will-change:transform,clip-path,opacity,filter;
}
/* Déchirure foil : pré-tension → fibres irrégulières → arrachement + reflet papier */
@keyframes packTopLipTear{
  0%{
    transform:rotateX(0deg) translateY(0) translateZ(0) rotateZ(0deg) scaleX(1);
    clip-path:polygon(0 0,100% 0,100% 100%,0 100%);
    opacity:1;
    filter:brightness(1) contrast(1) drop-shadow(0 2px 4px rgba(0,0,0,0.35));
  }
  6%{
    transform:rotateX(4deg) translateY(1px) translateZ(0) rotateZ(0.35deg) scaleX(1.008);
    filter:brightness(1.03) contrast(1.02) drop-shadow(0 3px 6px rgba(0,0,0,0.4));
  }
  14%{
    clip-path:polygon(0 0,100% 0,100% 100%,99.5% 88%,98.2% 94%,96% 78%,93% 96%,88% 72%,83% 94%,77% 68%,72% 91%,65% 64%,58% 89%,50% 60%,43% 93%,35% 58%,27% 90%,18% 62%,8% 88%,0 100%);
    transform:rotateX(-6deg) translateY(-1px) translateZ(4px) rotateZ(-0.5deg) scaleX(1.01);
    filter:brightness(1.06) contrast(1.05) drop-shadow(0 5px 10px rgba(0,0,0,0.42));
  }
  28%{
    clip-path:polygon(0 0,100% 0,100% 100%,99% 70%,97% 84%,94% 62%,90% 88%,85% 58%,80% 91%,73% 54%,67% 93%,59% 50%,51% 90%,42% 52%,33% 88%,24% 48%,14% 84%,0 100%);
    transform:rotateX(-22deg) translateY(-8px) translateZ(12px) rotateZ(-1.4deg) skewX(-0.8deg);
    filter:brightness(1.1) contrast(1.08) drop-shadow(0 8px 18px rgba(40,20,70,0.45));
  }
  42%{
    clip-path:polygon(0 0,100% 0,100% 100%,98% 42%,95% 58%,91% 32%,86% 52%,80% 22%,73% 45%,65% 18%,56% 38%,45% 12%,34% 32%,22% 8%,10% 22%,0 45%);
    transform:rotateX(-38deg) translateY(-16px) translateZ(20px) rotateZ(-2.1deg) skewX(-1.1deg);
    opacity:0.98;
  }
  58%{
    clip-path:polygon(0 0,100% 0,100% 18%,97% 8%,92% 2%,82% 0,65% 0,48% 0,32% 0,18% 0,8% 2%,0 8%);
    transform:rotateX(-50deg) translateY(-24px) translateZ(26px) rotateZ(-2.75deg) scale(0.96);
    filter:brightness(1.05) contrast(1.05) drop-shadow(0 12px 24px rgba(0,0,0,0.5));
    opacity:0.82;
  }
  74%{
    clip-path:polygon(0 0,100% 0,100% 0,92% 0,75% 0,50% 0,25% 0,10% 0,0 0);
    transform:rotateX(-58deg) translateY(-30px) translateZ(30px) rotateZ(-3deg) scale(0.9);
    opacity:0.45;
  }
  100%{
    clip-path:polygon(0 0,100% 0,100% 0,0 0);
    opacity:0;
    transform:rotateX(-64deg) translateY(-40px) translateZ(34px) rotateZ(-3.2deg) scale(0.84);
    filter:brightness(0.92) contrast(1.02) drop-shadow(0 16px 28px rgba(0,0,0,0.35));
  }
}
@media (prefers-reduced-motion:reduce){
  .pack-anim-box.phase-tear-top .pack-crimps--top{animation-duration:0.34s}
}
.pack-booster .pack-crest{
  flex:1;
  min-height:0;
  width:100%;
  margin:0;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:4px 0 6px;
  position:relative;
  z-index:3;
}
.pack-booster .pack-crest--overlay{margin-top:0;padding-top:2px}
.pack-booster .pack-trophy-frame{width:100px;height:100px}
.pack-booster .pack-trophy-img{
  filter:drop-shadow(0 8px 22px rgba(0,0,0,0.9)) brightness(1.1) contrast(1.08) saturate(1.1);
}
.pack-booster-lower{
  flex-shrink:0;
  width:100%;
  text-align:center;
  position:relative;
  z-index:3;
  padding:2px 2px 4px;
  margin-top:auto;
}
.pack-booster .pack-ttl{
  font-size:13px;
  letter-spacing:2px;
  margin-top:0;
  color:#bfdbfe;
  text-shadow:
    0 0 2px #0a0214,
    0 2px 4px rgba(0,0,0,0.95),
    0 4px 14px rgba(0,0,0,0.85),
    0 1px 0 rgba(255,250,220,0.45);
}
.pack-booster .pack-ttl::after{background:linear-gradient(90deg,transparent,rgba(242,217,138,0.45),transparent)}
.pack-booster .pack-subt{
  color:rgba(255,248,255,0.96);
  font-size:9px;
  font-weight:700;
  letter-spacing:1.7px;
  margin-top:5px;
  text-shadow:0 1px 4px rgba(0,0,0,0.95),0 0 14px rgba(0,0,0,0.7);
}
.pack-crest{position:relative;z-index:2;width:auto;height:auto;margin:0 0 14px;padding:0;border:none;background:none;box-shadow:none;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;min-height:100px}
.pack-crest--overlay{margin-top:34px}
.pack-trophy-frame{
  position:relative;z-index:1;width:112px;height:112px;
  background:transparent;
  border:none;
  box-shadow:none;
  display:flex;align-items:center;justify-content:center;
  overflow:visible;
}
.pack-trophy-img{
  width:100%;height:100%;object-fit:contain;object-position:center center;
  mix-blend-mode:normal;
  filter:brightness(1.28) contrast(1.05) saturate(1.1);
  -webkit-user-drag:none;user-select:none;pointer-events:none;
  display:block;
}
.pack-ttl{position:relative;z-index:2;font-family:'Orbitron',monospace;font-size:12px;font-weight:800;letter-spacing:1.5px;color:#ece8f4;text-align:center;line-height:1.25;text-shadow:0 1px 3px rgba(0,0,0,0.65);margin-top:2px}
.pack-ttl::after{content:'';display:block;width:40px;height:1px;margin:10px auto 0;background:linear-gradient(90deg,transparent,rgba(74, 144, 226,0.5),transparent)}
.pack-subt{position:relative;z-index:2;font-size:8px;font-weight:600;color:rgba(200,190,220,0.45);margin-top:6px;text-align:center;letter-spacing:1.6px;text-transform:uppercase}
.pack-open-row{width:100%;padding:0 16px 10px;display:flex;flex-direction:column;align-items:stretch;gap:12px}
.pack-cost-hero{
  text-align:center;padding:14px 16px 4px;border-radius:18px;
  border:1px solid rgba(255,255,255,0.08);
  background:linear-gradient(168deg,rgba(22,22,30,0.98) 0%,rgba(8,8,12,0.99) 100%);
  box-shadow:0 10px 32px rgba(0,0,0,0.45),inset 0 1px 0 rgba(255,255,255,0.06);
}
.pack-cost-hero__label{
  font-family:'Orbitron',monospace;font-size:9px;font-weight:700;letter-spacing:0.22em;color:rgba(74, 144, 226,0.75);text-transform:uppercase;margin-bottom:10px;
}
.pack-cost-hero__row{
  display:flex;align-items:center;justify-content:center;gap:10px;flex-wrap:wrap;
}
.pack-cost-hero__row--free{justify-content:center}
.pack-cost-hero__amt{
  font-family:'Orbitron',monospace;font-size:clamp(28px,9vw,40px);font-weight:900;letter-spacing:-0.02em;
  background:linear-gradient(135deg,#f0f9ff,#93c5fd 40%,#6ba3e8);
  -webkit-background-clip:text;-webkit-text-fill-color:transparent;
  filter:drop-shadow(0 2px 14px rgba(74, 144, 226,0.25));
  line-height:1;
}
.pack-cost-hero__unit{font-family:'Orbitron',monospace;font-size:11px;font-weight:700;color:rgba(200,195,215,0.65);text-transform:uppercase;letter-spacing:0.08em}
.pack-cost-hero__free{
  font-family:'Orbitron',monospace;font-size:clamp(22px,7vw,32px);font-weight:900;
  background:linear-gradient(135deg,#b8f5c8,#34d399,#059669);
  -webkit-background-clip:text;-webkit-text-fill-color:transparent;
}
.coin-ic--pack-hero{width:36px;height:36px;object-fit:contain;filter:drop-shadow(0 4px 12px rgba(74, 144, 226,0.35))}
/* Même base que le CTA accueil (.cta-btn) — dégradé rose/corail, reflet shine */
.cta-btn.pack-open-btn{
  width:100%;
  max-width:100%;
  min-width:0;
  min-height:48px;
  display:flex;
  align-items:center;
  justify-content:center;
  color:#fff;
}
.pack-open-btn-inner{
  display:inline-flex;align-items:center;justify-content:center;gap:10px;
  position:relative;z-index:1;
}
.pack-open-btn-inner--free{
  font-size:clamp(17px,5vw,20px);font-weight:900;letter-spacing:0.1em;
  color:#fff;
}
.pack-open-btn__num{
  font-family:'Orbitron',monospace;font-size:clamp(20px,6vw,26px);font-weight:900;letter-spacing:-0.02em;line-height:1;
  color:#fff;
  -webkit-text-fill-color:#fff;
}
.pack-open-btn-inner--ticket .pack-open-btn__num{
  color:#fff;
  -webkit-text-fill-color:#fff;
}
.coin-ic--packbtn{width:28px;height:28px;object-fit:contain;filter:drop-shadow(0 1px 2px rgba(0,0,0,0.2))}
.pack-open-btn__ticket-ic{width:28px;height:28px;object-fit:contain;filter:drop-shadow(0 1px 2px rgba(0,0,0,0.2));-webkit-user-drag:none;user-select:none}
.cta-btn.pack-open-btn:disabled{opacity:0.45;cursor:not-allowed;filter:grayscale(0.35)}
.pack-price-hint{text-align:center;font-size:10px;color:var(--muted);margin-top:0;padding:0 12px;line-height:1.5}
.pack-price-hint--balance{font-size:11px;color:rgba(200,195,215,0.82)}
.pack-price-hint img{vertical-align:-3px;margin-left:1px}
.pack-odds-hdr{font-size:9px;letter-spacing:2px;color:var(--muted);text-transform:uppercase;margin-bottom:10px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:6px}
.pack-odds-note{font-size:8px;font-weight:500;letter-spacing:0;color:rgba(232,224,255,0.35);text-transform:none;max-width:100%}
.pack-odd-row{display:flex;align-items:center;gap:10px;margin-bottom:10px}
.pack-odd-row:last-child{margin-bottom:0}
.pack-odd-ic{width:36px;min-height:36px;display:flex;align-items:center;justify-content:center;font-size:24px;line-height:1;flex-shrink:0;background:none;border:none;box-shadow:none;padding:0}
.pack-odd-img{width:32px;height:32px;object-fit:contain;object-position:center;display:block;border-radius:6px;filter:drop-shadow(0 2px 6px rgba(0,0,0,0.45))}
.pack-odd-img--spin{width:36px;height:36px}
.pack-odd-img--ticket{width:36px;height:36px}
.pack-odd-img--device{width:38px;height:38px}
.pack-odd-row:has(.pack-odd-img--device) .pack-odd-ic{min-width:40px;width:40px;min-height:40px}
.pack-odd-img--iphone{width:44px;height:44px}
.pack-odd-row:has(.pack-odd-img--iphone) .pack-odd-ic{min-width:46px;width:46px;min-height:46px}
.pack-odd-img--travel{width:40px;height:40px}
.pack-odd-row:has(.pack-odd-img--travel) .pack-odd-ic{min-width:42px;width:42px;min-height:42px}
.pack-odd-body{flex:1;min-width:0}
.pack-odd-name{font-size:12px;font-weight:700;color:var(--text);line-height:1.2}
.pack-odd-pct{font-family:'Orbitron',monospace;font-size:10px;font-weight:700;margin-top:2px}
.pack-odd-pct.r-c{color:rgba(180,190,210,0.9)}
.pack-odd-pct.r-u{color:var(--neon)}
.pack-odd-pct.r-r{color:#88ccff}
.pack-odd-pct.r-e{color:var(--neon2)}
.pack-odd-pct.r-l{color:var(--gold)}
.pack-odd-pct.r-g{background:linear-gradient(90deg,var(--gold),var(--neon2));-webkit-background-clip:text;-webkit-text-fill-color:transparent;font-weight:900}
.pack-odd-bar{height:6px;border-radius:4px;margin-top:5px;overflow:hidden;border:1px solid #1c1c20;background-color:#050506;background-image:linear-gradient(180deg,#111116 0%,#08080a 100%);box-shadow:inset 0 2px 4px rgba(0,0,0,0.55),inset 0 1px 0 rgba(255,255,255,0.03)}
.pack-odd-fill{height:100%;border-radius:3px;transition:width 0.8s cubic-bezier(.22,1,.36,1)}
.pack-god-callout{margin-top:12px;padding:12px 14px;border-radius:12px;border:1px solid rgba(107, 163, 232,0.38);background:linear-gradient(165deg,rgba(28,22,14,0.96) 0%,rgba(10,8,6,0.99) 100%);text-align:center;box-shadow:0 6px 20px rgba(0,0,0,0.35),inset 0 1px 0 rgba(226,186,88,0.08)}
.pack-god-callout .g1{font-family:'Orbitron',monospace;font-size:10px;font-weight:800;color:rgba(191, 219, 254,0.95);letter-spacing:1px}
.pack-god-callout .g2{font-size:9px;color:var(--muted);margin-top:4px;line-height:1.4}

/* Overlay ouverture pack */
.pack-ov{position:fixed;inset:0;z-index:var(--gs-z-modal, 1000);display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(6,10,24,0.92);opacity:0;visibility:hidden;pointer-events:none;transition:opacity 0.35s ease,visibility 0.35s;overflow:hidden;padding:max(12px, env(safe-area-inset-top, 0px)) max(12px, env(safe-area-inset-right, 0px)) max(16px, env(safe-area-inset-bottom, 0px)) max(12px, env(safe-area-inset-left, 0px));box-sizing:border-box}
.pack-ov.on{opacity:1;visibility:visible;pointer-events:auto}
.pack-ov-glow{position:absolute;z-index:2;width:130%;height:55%;top:12%;left:50%;transform:translateX(-50%);background:radial-gradient(ellipse,rgba(74, 144, 226,0.12),transparent 68%);animation:ovGlowPulse 4.2s ease-in-out infinite;pointer-events:none}
@keyframes ovGlowPulse{0%,100%{opacity:0.55;transform:translateX(-50%) scale(1)}50%{opacity:0.85;transform:translateX(-50%) scale(1.02)}}
.pack-ov-particles{position:absolute;z-index:3;inset:0;overflow:hidden;pointer-events:none;opacity:0.88}
.pov-dot{position:absolute;left:50%;top:42%;width:4px;height:4px;border-radius:50%;background:#4a90e2;box-shadow:0 0 8px rgba(74, 144, 226,0.55);opacity:0;animation:povBurst 1s ease-out forwards}
@keyframes povBurst{0%{opacity:1;transform:translate(-50%,-50%) translate(0,0) scale(1)}100%{opacity:0;transform:translate(-50%,-50%) translate(var(--dx),var(--dy)) scale(0.15)}}

.pack-anim-stage{position:relative;z-index:5;width:min(300px,92vw);min-height:480px;height:auto;display:flex;align-items:center;justify-content:center;transform-style:preserve-3d;overflow:visible;padding:28px 0 28px}
.pack-anim-stack{
  position:relative;
  width:100%;
  min-height:400px;
  display:flex;
  align-items:center;
  justify-content:center;
  overflow:visible;
  perspective:1500px;
  perspective-origin:50% 38%;
  transform-style:preserve-3d;
  -webkit-transform-style:preserve-3d;
  --pack-body-w:170px;
  --pack-body-h:206px;
  --pack-lip-h:26px;
  /* Largeur carte < corps du pack ; hauteur = corps (206) */
  --pack-card-w:152px;
  --pack-fente-lift:14px;
  --pack-card-slide-end:calc(-1 * var(--pack-body-h) + var(--pack-fente-lift));
}
/* Slot = zone du corps violet uniquement : top = ligne de déchirure, carte en top:0 = premier pixel sous la languette foil */
.pack-anim-box.pack-booster .pack-card-slot{
  position:absolute;
  left:50%;
  top:var(--pack-lip-h);
  width:var(--pack-body-w);
  height:var(--pack-body-h);
  transform:translateX(-50%) translateZ(0);
  overflow:visible;
  -webkit-clip-path:inset(-400px 0 0 0);
  clip-path:inset(-400px 0 0 0);
  z-index:12;
  pointer-events:none;
  transform-style:preserve-3d;
  -webkit-transform-style:preserve-3d;
  -webkit-backface-visibility:hidden;
  backface-visibility:hidden;
}
.pack-anim-box.pack-booster .pack-card-slot.slot-released{
  -webkit-clip-path:none;
  clip-path:none;
  z-index:40;
}
.pack-anim-box.pack-booster .pack-card-slot .pack-reveal-card{
  position:absolute;
  left:50%;
  top:calc(var(--pack-lip-h) + (var(--pack-body-h) / 2));
  z-index:1;
  transform:translate3d(-50%,-50%,0);
  transform-style:preserve-3d;
  -webkit-transform-style:preserve-3d;
}
/* Booster : départ plus haut (proche bord) ; fin slide = bas de carte sur la fente */
.pack-anim-box.pack-booster .pack-card-slot .pack-reveal-card.pack-reveal-booster{
  top:calc(-1 * var(--pack-fente-lift));
  bottom:auto;
  transform:translate3d(-50%,0,0);
  transform-origin:50% 0;
}
.pack-anim-box.pack-booster .pack-reveal-card.reveal-in-front{
  z-index:2;
}
.pack-anim-box.pack-booster .pack-reveal-card.pack-reveal-booster.reveal-in-front{
  opacity:1;
  /* Pas de filter sur la carte : netteté max + preserve-3d pour le flip */
  -webkit-font-smoothing:auto;
  box-shadow:
    0 24px 48px rgba(0,0,0,0.42),
    0 0 40px rgba(74, 144, 226,0.22),
    0 0 0 1px rgba(107, 163, 232,0.18);
}
.pack-anim-stack .pack-anim-box{
  position:relative;
  z-index:2;
  transform:translateZ(0);
  transform-style:preserve-3d;
  -webkit-transform-style:preserve-3d;
  transition:transform 0.6s cubic-bezier(.25,.82,.28,1);
}
/* Assombrir seulement la face du pack : un filter sur la box entière floute aussi la carte (sous-arbre rasterisé) */
.pack-anim-stack .pack-anim-box > .pack-face{
  transition:filter 0.55s ease,opacity 0.55s ease;
}
.pack-anim-stack.pack-card-forward .pack-anim-box{
  transform:translateY(14px) translateZ(-18px) scale(1);
}
.pack-anim-stack.pack-card-forward .pack-anim-box > .pack-face{
  filter:brightness(0.9) saturate(0.96);
  opacity:0.96;
}
@media (prefers-reduced-motion:reduce){
  .pack-anim-stack.pack-card-forward .pack-anim-box{
    transform:translateY(10px) translateZ(-12px) scale(1);
    transition-duration:0.35s;
  }
  .pack-anim-stack.pack-card-forward .pack-anim-box > .pack-face{
    filter:brightness(0.92) saturate(0.97);
  }
}
.pack-anim-box{width:170px;height:258px;position:relative;transform-style:preserve-3d}
.pack-anim-box.pack-shake-go{animation:packShake 0.11s ease-in-out 6}
@media (prefers-reduced-motion:reduce){
  .pack-anim-box.pack-shake-go{animation:packShake 0.12s ease-in-out 3}
}
@keyframes packShake{0%,100%{transform:translate(0,0) rotate(0)}25%{transform:translate(-3px,2px) rotate(-2deg)}75%{transform:translate(3px,-2px) rotate(2deg)}}
.pack-anim-box.pack-booster{overflow:visible}

.pack-reveal-card{width:200px;min-height:220px;border-radius:14px;border:1px solid rgba(107, 163, 232,0.38);background:linear-gradient(165deg,#1a1610 0%,#12100c 55%,#0c0a08 100%);box-shadow:0 20px 48px rgba(0,0,0,0.5),inset 0 1px 0 rgba(226,186,88,0.1);padding:20px 16px;text-align:center;flex-direction:column;align-items:center;justify-content:center;opacity:0;transform:translate(-50%,-50%) rotateY(88deg) scale(0.4);position:relative;overflow:visible}
.pack-reveal-card.reveal-play{
  animation:packCardRevealCinema 2.38s cubic-bezier(.17,.93,.28,1) forwards;
}
.pack-reveal-card.pack-reveal-booster.reveal-play{
  transform-origin:50% 0;
  animation:packCardRevealCinemaBooster 2.95s cubic-bezier(0.42,0,0.2,1) forwards;
}
.pack-reveal-card.r-god{border-color:rgba(253,224,71,0.45);box-shadow:0 20px 56px rgba(0,0,0,0.55),0 0 32px rgba(74, 144, 226,0.22),inset 0 1px 0 rgba(255,248,220,0.12)}
@keyframes packCardRevealCinema{
  0%{opacity:0;transform:translate(-50%,-40%) translateZ(-100px) scale(0.68) rotateX(58deg) rotateY(-20deg);filter:drop-shadow(0 6px 14px rgba(0,0,0,0.35))}
  10%{opacity:0.55}
  28%{opacity:1;transform:translate(-50%,-49%) translateZ(-58px) scale(0.78) rotateX(42deg) rotateY(-14deg);filter:drop-shadow(0 12px 24px rgba(0,0,0,0.45))}
  48%{transform:translate(-50%,-54%) translateZ(12px) scale(0.9) rotateX(16deg) rotateY(-5deg);filter:drop-shadow(0 18px 32px rgba(0,0,0,0.5))}
  68%{transform:translate(-50%,-56%) translateZ(118px) scale(1.06) rotateX(-6deg) rotateY(3deg);filter:drop-shadow(0 26px 48px rgba(0,0,0,0.55)) drop-shadow(0 0 28px rgba(74, 144, 226,0.2))}
  82%{transform:translate(-50%,-51%) translateZ(108px) scale(1.11) rotateX(1.5deg) rotateY(-0.5deg);filter:drop-shadow(0 30px 54px rgba(0,0,0,0.52)) drop-shadow(0 0 36px rgba(74, 144, 226,0.26))}
  100%{opacity:1;transform:translate(-50%,-50%) translateZ(96px) scale(1.08) rotateX(0deg) rotateY(0deg);filter:drop-shadow(0 28px 52px rgba(0,0,0,0.5)) drop-shadow(0 0 32px rgba(74, 144, 226,0.22))}
}
/* Départ à la fente (bandeau visible) ; clip masque le bas = pas encore sorti du pack ; fin : bas de carte sur la fente */
@keyframes packCardRevealCinemaBooster{
  0%{
    opacity:1;
    transform:translate3d(-50%,0,0);
    -webkit-clip-path:inset(0 0 94% 0 round 7px);
    clip-path:inset(0 0 94% 0 round 7px);
  }
  100%{
    opacity:1;
    transform:translate3d(-50%,var(--pack-card-slide-end),0);
    -webkit-clip-path:inset(0 0 0 0 round 7px);
    clip-path:inset(0 0 0 0 round 7px);
  }
}
@keyframes packCardRevealSettle{
  from{
    opacity:1;
    transform:translate3d(-50%,var(--pack-card-slide-end),0);
    -webkit-clip-path:inset(0 0 0 0 round 7px);
    clip-path:inset(0 0 0 0 round 7px);
  }
  to{
    opacity:1;
    transform:translate3d(-50%,0,118px);
    -webkit-clip-path:inset(0 0 0 0 round 7px);
    clip-path:inset(0 0 0 0 round 7px);
  }
}
.pack-reveal-card.pack-reveal-booster.reveal-play.pack-card-do-settle{
  opacity:1;
  transform-origin:50% 0;
  animation:packCardRevealSettle 1.02s cubic-bezier(0.22,1,0.36,1) forwards;
}
@media (prefers-reduced-motion:reduce){
  .pack-reveal-card.reveal-play:not(.pack-reveal-booster){animation:packCardRevealReduced 0.58s cubic-bezier(.25,1,.35,1) forwards;animation-delay:0s}
  .pack-reveal-card.pack-reveal-booster.reveal-play{animation:packCardRevealReducedBooster 0.58s cubic-bezier(.25,1,.35,1) forwards;animation-delay:0s}
}
@keyframes packCardRevealReduced{
  0%{opacity:0;clip-path:inset(0 0 0 0);transform:translate(-50%,-46%) translateZ(-30px) scale(1)}
  100%{opacity:1;clip-path:inset(0 0 0 0);transform:translate(-50%,-50%) translateZ(36px) scale(1)}
}
@keyframes packCardRevealReducedBooster{
  0%{opacity:0;-webkit-clip-path:inset(0 0 94% 0 round 7px);clip-path:inset(0 0 94% 0 round 7px);transform:translate3d(-50%,0,0)}
  100%{opacity:1;-webkit-clip-path:inset(0 0 0 0 round 7px);clip-path:inset(0 0 0 0 round 7px);transform:translate3d(-50%,0,118px)}
}
/* Carte : largeur réduite, hauteur = corps ; fond violet de secours (évite flash noir) */
.pack-reveal-card.pack-reveal-booster{
  perspective:1100px;
  perspective-origin:50% 48%;
  -webkit-perspective:1100px;
  width:var(--pack-card-w,152px);
  height:var(--pack-body-h,206px);
  min-height:var(--pack-body-h,206px);
  max-height:var(--pack-body-h,206px);
  flex-shrink:0;
  flex-direction:column;
  align-items:stretch;
  border:none;
  background:linear-gradient(165deg,#1e3c8c 0%,#0a143c 42%,#050a1e 100%);
  box-shadow:none;
  padding:0;
  overflow:visible;
  box-sizing:border-box;
}
.pack-reveal-card.pack-reveal-booster::before,
.pack-reveal-card.pack-reveal-booster::after{display:none}

/* Verso pendant le glissement ; recto dès .pack-card-show-front. Tranche 3D = pas de « vide » à 90°. */
.pack-card-flip-inner{
  position:relative;
  width:100%;
  height:100%;
  transform-style:preserve-3d;
  -webkit-transform-style:preserve-3d;
  transform:rotateY(0deg);
  transform-origin:50% 50%;
  transition:transform 0.58s cubic-bezier(0.34,1.15,0.34,1);
}
.pack-reveal-card.pack-reveal-booster .pack-card-flip-inner{
  --pack-card-half-depth:2.5px;
}
.pack-reveal-card.pack-reveal-booster.pack-card-show-front .pack-card-flip-inner{
  transform:rotateY(180deg);
}
@media (prefers-reduced-motion:reduce){
  .pack-card-flip-inner{transition:none}
}
/* Bande d’épaisseur : visible quand la carte est de profil (remplace l’entre-deux vide) */
.pr-card-edge{
  position:absolute;
  left:50%;
  top:3px;
  bottom:3px;
  width:calc(2 * var(--pack-card-half-depth,2.5px));
  margin-left:calc(-1 * var(--pack-card-half-depth,2.5px));
  border-radius:1px;
  transform:rotateY(90deg);
  transform-style:preserve-3d;
  background:
    repeating-linear-gradient(180deg,rgba(255,255,255,0.04) 0 1px,transparent 1px 4px),
    linear-gradient(90deg,#040208 0%,#2a5099 35%,#93c5fd 48%,#2a5099 62%,#0a143c 100%);
  box-shadow:
    inset 0 0 16px rgba(0,0,0,0.92),
    inset 0 0 5px rgba(255,220,255,0.07);
  pointer-events:none;
  -webkit-backface-visibility:visible;
  backface-visibility:visible;
}
.pr-card-back,.pr-card-front{
  position:absolute;
  inset:0;
  border-radius:7px;
  -webkit-backface-visibility:hidden;
  backface-visibility:hidden;
  overflow:hidden;
  box-sizing:border-box;
  outline:none;
  border:none;
}
.pr-card-back{
  transform:rotateY(0deg) translateZ(var(--pack-card-half-depth,2.5px));
}
.pr-card-front{
  transform:rotateY(180deg) translateZ(var(--pack-card-half-depth,2.5px));
}
.pr-pack-back-inner{
  width:100%;
  height:100%;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:10px 10px 11px;
  box-sizing:border-box;
  background:
    linear-gradient(92deg, rgba(255,255,255,0.32) 0%, rgba(255,220,180,0.1) 14%, transparent 32%),
    linear-gradient(100deg, transparent 0%, transparent 46%, rgba(0,0,0,0.42) 100%),
    linear-gradient(270deg, rgba(255,248,235,0.06) 0%, transparent 18%),
    radial-gradient(ellipse 92% 78% at 50% 45%, rgba(255,200,120,0.4) 0%, rgba(140,85,28,0.72) 24%, rgba(45,28,10,0.94) 50%, rgba(8,4,2,0.99) 76%, #030201 100%),
    linear-gradient(180deg,#1a3278 0%,#0f1d4a 38%,#080402 100%);
  box-shadow:
    inset 0 0 0 2px #080604,
    inset 0 0 0 4px rgba(74, 144, 226,0.22),
    inset 22px 0 48px rgba(255,230,200,0.08),
    inset -26px 0 54px rgba(0,0,0,0.5),
    inset 0 22px 50px rgba(255,180,100,0.06),
    inset 0 -28px 55px rgba(0,0,0,0.58),
    0 18px 44px rgba(0,0,0,0.65);
}
.pr-pack-back-inner::after{
  content:'';
  position:absolute;
  inset:5px;
  border-radius:5px;
  border:1px solid rgba(107, 163, 232,0.14);
  pointer-events:none;
  z-index:0;
}
.pr-trophy-wrap--back{
  flex:1;
  min-height:0;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:4px 0 6px;
  position:relative;
  z-index:1;
}
.pr-pack-back-inner .pack-trophy-img{
  width:100px;
  height:100px;
  object-fit:contain;
  filter:drop-shadow(0 8px 22px rgba(0,0,0,0.9)) brightness(1.1) contrast(1.05) saturate(1.08);
}
.pr-pack-back-ttl{
  font-family:'Orbitron',monospace;
  font-size:13px;
  font-weight:800;
  letter-spacing:2px;
  line-height:1.2;
  text-align:center;
  color:#bfdbfe;
  position:relative;
  z-index:1;
  margin:0 0 4px;
  text-shadow:
    0 0 2px #0a0214,
    0 2px 4px rgba(0,0,0,0.95),
    0 4px 14px rgba(0,0,0,0.85),
    0 1px 0 rgba(255,250,220,0.45);
}
.pr-pack-back-sub{
  font-size:8px;
  font-weight:600;
  letter-spacing:1.6px;
  text-transform:uppercase;
  color:rgba(200,190,220,0.45);
  position:relative;
  z-index:1;
  margin-top:auto;
  padding-bottom:2px;
}

/* Carte gain = même graphisme que le corps du pack (holo or / ambre) */
.pr-violet-face{
  position:relative;
  width:100%;
  height:100%;
  box-sizing:border-box;
  border-radius:7px;
  overflow:hidden;
  isolation:isolate;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:10px 10px 11px;
  background:
    linear-gradient(92deg, rgba(255,255,255,0.32) 0%, rgba(255,220,180,0.1) 14%, transparent 32%),
    linear-gradient(100deg, transparent 0%, transparent 46%, rgba(0,0,0,0.42) 100%),
    linear-gradient(270deg, rgba(255,248,235,0.06) 0%, transparent 18%),
    radial-gradient(ellipse 92% 78% at 50% 45%, rgba(255,200,120,0.4) 0%, rgba(140,85,28,0.72) 24%, rgba(45,28,10,0.94) 50%, rgba(8,4,2,0.99) 76%, #030201 100%),
    linear-gradient(180deg,#1a3278 0%,#0f1d4a 38%,#080402 100%);
  box-shadow:
    inset 0 0 0 2px #080604,
    inset 0 0 0 4px rgba(74, 144, 226,0.22),
    inset 22px 0 48px rgba(255,230,200,0.08),
    inset -26px 0 54px rgba(0,0,0,0.5),
    inset 0 22px 50px rgba(255,180,100,0.06),
    inset 0 -28px 55px rgba(0,0,0,0.58),
    0 18px 44px rgba(0,0,0,0.65);
}
.pr-violet-face::after{
  content:'';
  position:absolute;
  inset:5px;
  border-radius:5px;
  border:1px solid rgba(107, 163, 232,0.14);
  pointer-events:none;
  z-index:0;
}
.pr-violet-shine{
  position:absolute;
  inset:0;
  background:linear-gradient(125deg,transparent 28%,rgba(255,255,255,0.06) 46%,transparent 64%);
  animation:prVioletShine 5.5s ease-in-out infinite;
  pointer-events:none;
  z-index:0;
}
@keyframes prVioletShine{
  0%,100%{opacity:0.4;transform:translateX(-7%)}
  50%{opacity:0.78;transform:translateX(7%)}
}
@media (prefers-reduced-motion:reduce){
  .pr-violet-shine{display:none}
}
.pack-reveal-card.pack-reveal-booster .pr-trophy-wrap{
  flex:1;
  min-height:0;
  width:100%;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:4px 0 6px;
  position:relative;
  z-index:1;
  margin:0 0 4px 0;
}
.pack-reveal-card.pack-reveal-booster .pr-reveal-img{
  max-width:min(102px,58%);
  max-height:min(92px,27vw);
  filter:drop-shadow(0 8px 22px rgba(0,0,0,0.9)) brightness(1.08) contrast(1.05) saturate(1.08);
}
/* Image finale : pas de drop-shadow / filter GPU = bords nets (le relief vient du visuel .pr-violet-face + box-shadow carte) */
.pack-reveal-card.pack-reveal-booster.reveal-in-front .pr-reveal-img{
  filter:none;
  image-rendering:auto;
  -webkit-backface-visibility:hidden;
  backface-visibility:hidden;
}
.pr-violet-ttl{
  font-family:'Orbitron',monospace;
  font-size:12px;
  font-weight:800;
  line-height:1.3;
  letter-spacing:0.4px;
  color:#bfdbfe;
  text-align:center;
  position:relative;
  z-index:1;
  margin:0 0 4px 0;
  padding:0 2px;
  text-shadow:
    0 0 2px #060010,
    0 2px 5px rgba(0,0,0,0.95),
    0 4px 14px rgba(0,0,0,0.85),
    0 1px 0 rgba(255,250,230,0.42);
}
.pr-violet-desc{
  font-size:10px;
  line-height:1.45;
  color:rgba(255,248,255,0.94);
  text-align:center;
  position:relative;
  z-index:1;
  padding:0 3px 2px;
  text-shadow:0 1px 4px rgba(0,0,0,0.9),0 2px 10px rgba(0,0,0,0.65);
}
.pack-reveal-card.pack-reveal-booster .pr-rarity{
  position:relative;
  z-index:1;
  margin:0 0 4px 0;
  font-size:8px;
  font-weight:700;
  letter-spacing:2px;
  text-transform:uppercase;
}
.pack-reveal-card.pack-reveal-booster .pr-rarity.common{color:#ebe4ff;text-shadow:0 1px 4px #000,0 0 10px rgba(0,0,0,0.8)}
.pack-reveal-card.pack-reveal-booster .pr-rarity.uncommon{color:#9cf0ff;text-shadow:0 1px 4px #000,0 0 10px rgba(0,0,0,0.8)}
.pack-reveal-card.pack-reveal-booster .pr-rarity.rare{color:#b8ddff;text-shadow:0 1px 4px #000,0 0 10px rgba(0,0,0,0.8)}
.pack-reveal-card.pack-reveal-booster .pr-rarity.epic{color:#f0b8ff;text-shadow:0 1px 4px #000,0 0 10px rgba(0,0,0,0.8)}
.pack-reveal-card.pack-reveal-booster .pr-rarity.legend{color:#ffe3a8;text-shadow:0 1px 4px #000,0 0 10px rgba(0,0,0,0.8)}
.pack-reveal-card.pack-reveal-booster .pr-rarity.god{
  background:linear-gradient(92deg,#ffd88a,#f0f9ff,#e8a8ff,#ffd88a);
  -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
  filter:drop-shadow(0 2px 4px rgba(0,0,0,0.95));
}
.pack-reveal-card.pack-reveal-booster.r-god .pr-card-front .pr-violet-face{
  box-shadow:
    inset 0 0 0 2px #010008,
    inset 0 0 0 4px rgba(220,190,255,0.38),
    inset 22px 0 48px rgba(255,210,255,0.1),
    inset -26px 0 54px rgba(0,0,0,0.45),
    0 20px 50px rgba(0,0,0,0.72),
    0 0 52px rgba(140,80,255,0.45);
}
@keyframes cardFlipIn{0%{transform:rotateY(88deg) scale(0.4);opacity:0}60%{transform:rotateY(-6deg) scale(1.02);opacity:1}100%{transform:rotateY(0) scale(1);opacity:1}}

.pr-trophy-wrap{width:100%;display:flex;justify-content:center;align-items:center;margin-bottom:8px;min-height:min(120px,30vw)}
.pr-reveal-img{max-width:min(132px,70%);max-height:min(118px,32vw);width:auto;height:auto;object-fit:contain;object-position:center;display:block;margin:0 auto;filter:drop-shadow(0 4px 14px rgba(0,0,0,0.45))}
.pack-reveal-card.reveal-play .pr-reveal-img{animation:prPop 0.65s cubic-bezier(.22,1,.36,1) 0.4s both}
/* Pas d’anim sur l’image pendant le glissement (évite saccades GPU) — pop à la fin */
.pack-reveal-card.pack-reveal-booster.reveal-play .pr-reveal-img{animation:none;transform:none}
.pack-reveal-card.pack-reveal-booster.reveal-in-front.pack-card-show-front .pr-reveal-img{
  animation:prPop 0.52s cubic-bezier(.22,1,.36,1) 0.32s both;
}
@keyframes prPop{0%{transform:scale(0) rotate(-20deg)}70%{transform:scale(1.15) rotate(4deg)}100%{transform:scale(1) rotate(0)}}
@media (prefers-reduced-motion:reduce){
  .pack-reveal-card.pack-reveal-booster.reveal-play .pr-reveal-img{animation:none;transform:none}
  .pack-reveal-card.pack-reveal-booster.reveal-in-front.pack-card-show-front .pr-reveal-img{animation:prPop 0.4s cubic-bezier(.22,1,.36,1) 0.12s both}
}
.pr-title{font-family:'Orbitron',monospace;font-size:14px;font-weight:800;line-height:1.25;margin-bottom:6px;background:linear-gradient(135deg,#F5E6E9,var(--gold),var(--gold2) 55%,#3b78c8);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;filter:drop-shadow(0 2px 3px rgba(0,0,0,0.75))}
.pr-sub{font-size:11px;color:var(--muted);line-height:1.45;margin-bottom:14px}
.pr-rarity{font-size:9px;font-weight:700;letter-spacing:2px;text-transform:uppercase;margin-bottom:12px}
.pr-rarity.common{color:rgba(180,190,210,0.9)}
.pr-rarity.uncommon{color:var(--neon)}
.pr-rarity.rare{color:#88ccff}
.pr-rarity.epic{color:var(--neon2)}
.pr-rarity.legend{color:var(--gold)}
.pr-rarity.god{background:linear-gradient(90deg,var(--gold),#fff,var(--neon2));-webkit-background-clip:text;-webkit-text-fill-color:transparent}

.pack-confetti-canvas{position:absolute;inset:0;width:100%;height:100%;z-index:18;pointer-events:none;display:block;opacity:0.82}
.pack-ov-claim-hint{
  position:relative;z-index:55;max-width:min(340px,92vw);margin:10px auto 0;padding:0 14px;
  font-family:'Rajdhani',sans-serif;font-size:12px;font-weight:600;line-height:1.45;text-align:center;
  color:rgba(220,210,235,0.88);text-shadow:0 1px 10px rgba(0,0,0,0.75);
}
.pack-ov-claim-hint[hidden]{display:none !important}
.pack-ov-close{
  margin-top:10px;width:min(100%,340px);opacity:0;pointer-events:none;
  position:relative;z-index:60;overflow:hidden;
  transition:opacity 0.45s ease 0.15s,transform 0.15s;
  font-family:inherit;letter-spacing:0.06em;
}
.pack-ov-close::after{content:'';position:absolute;top:0;left:-100%;width:100%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,0.22),transparent);animation:shine 7s infinite;pointer-events:none}
.pack-ov-close.show{opacity:1;pointer-events:auto}

/* ── Global Pack : carte pack bleu alpine + trophée ── */
.pack-booster .pack-body-core,
.pr-pack-back-inner,
.pr-violet-face{
  background:
    linear-gradient(92deg,rgba(255,255,255,0.26) 0%,rgba(147,197,253,0.14) 16%,transparent 34%),
    linear-gradient(100deg,transparent 0%,transparent 44%,rgba(0,0,0,0.36) 100%),
    linear-gradient(270deg,rgba(191,219,254,0.1) 0%,transparent 20%),
    radial-gradient(ellipse 90% 76% at 50% 40%,rgba(147,197,253,0.5) 0%,rgba(74,144,226,0.68) 24%,rgba(30,70,150,0.94) 50%,rgba(8,16,48,0.99) 74%,#040818 100%),
    linear-gradient(180deg,#2563b8 0%,#1e3c8c 40%,#0a143c 100%) !important;
  box-shadow:
    inset 0 0 0 2px rgba(8,14,40,0.95),
    inset 0 0 0 4px rgba(107,163,232,0.38),
    inset 20px 0 42px rgba(191,219,254,0.07),
    inset -22px 0 46px rgba(0,0,0,0.48),
    inset 0 18px 44px rgba(147,197,253,0.1),
    inset 0 -22px 48px rgba(0,0,0,0.52) !important;
}
.pack-booster .pack-body-core::after,
.pr-pack-back-inner::after,
.pr-violet-face::after{
  border-color:rgba(147,197,253,0.22) !important;
}
.pack-booster .pack-trophy-frame{
  width:108px !important;
  height:108px !important;
}
.pack-booster .pack-trophy-img,
.pr-pack-back-inner .pack-trophy-img{
  filter:drop-shadow(0 8px 24px rgba(74,144,226,0.55)) drop-shadow(0 2px 8px rgba(0,0,0,0.75)) brightness(1.12) contrast(1.04) saturate(1.05) !important;
}
.pack-booster .pack-ttl,
.pr-pack-back-ttl{
  color:#e0f2fe !important;
  text-shadow:0 0 12px rgba(74,144,226,0.45),0 2px 6px rgba(0,0,0,0.9) !important;
}
.pack-booster .pack-ttl::after{
  background:linear-gradient(90deg,transparent,rgba(147,197,253,0.55),transparent) !important;
}
.pack-crimps--top,
.pack-crimps--bottom{
  background:linear-gradient(180deg,#2a5099 0%,#4a90e2 38%,#1e3c8c 72%,#0f1d4a 100%) !important;
}
.global-pack-view .pack-open-btn,
.global-pack-view .cta-btn.pack-open-btn{
  width:100% !important;
  max-width:100% !important;
}
.pack-open-btn-inner{
  gap:6px !important;
}
.pack-open-btn__num{
  font-size:clamp(17px,4.5vw,21px) !important;
}
.pack-open-btn-inner--free{
  font-size:clamp(15px,4vw,18px) !important;
  letter-spacing:0.14em !important;
}

/* ── Notification créditation liquid glass ── */
.pack-credit-glass{
  position:relative;z-index:56;max-width:min(360px,92vw);margin:12px auto 0;padding:0 12px;
  opacity:0;transform:translateY(14px) scale(0.96);
  transition:opacity 0.55s cubic-bezier(0.22,1,0.36,1),transform 0.55s cubic-bezier(0.22,1,0.36,1);
  pointer-events:none;
}
.pack-credit-glass--show{
  opacity:1;transform:translateY(0) scale(1);
}
.pack-credit-glass__inner{
  position:relative;overflow:hidden;border-radius:20px;padding:18px 20px 16px;text-align:center;
  background:linear-gradient(145deg,rgba(255,255,255,0.14) 0%,rgba(74,144,226,0.08) 40%,rgba(15,25,55,0.22) 100%);
  backdrop-filter:blur(22px) saturate(1.35);
  -webkit-backdrop-filter:blur(22px) saturate(1.35);
  border:1px solid rgba(255,255,255,0.22);
  box-shadow:0 8px 40px rgba(0,0,0,0.35),0 0 0 1px rgba(147,197,253,0.12) inset,0 2px 0 rgba(255,255,255,0.18) inset;
}
.pack-credit-glass__shine{
  position:absolute;inset:0;border-radius:inherit;pointer-events:none;
  background:linear-gradient(118deg,transparent 30%,rgba(255,255,255,0.22) 48%,transparent 66%);
  animation:packCreditShine 4.2s ease-in-out infinite;
}
@keyframes packCreditShine{
  0%,100%{opacity:0.35;transform:translateX(-30%)}
  50%{opacity:0.85;transform:translateX(30%)}
}
.pack-credit-glass__icon{
  display:flex;align-items:center;justify-content:center;margin:0 auto 8px;
  width:52px;height:52px;border-radius:50%;
  background:rgba(255,255,255,0.08);
  border:1px solid rgba(255,255,255,0.2);
  box-shadow:0 4px 20px rgba(74,144,226,0.25);
}
.pack-credit-glass__emoji{font-size:1.75rem;line-height:1}
.pack-credit-glass__badge{
  display:inline-block;margin-bottom:6px;padding:3px 10px;border-radius:999px;
  font-family:'Orbitron',monospace;font-size:9px;font-weight:700;letter-spacing:0.12em;
  color:#e0f2fe;background:rgba(74,144,226,0.35);
  border:1px solid rgba(147,197,253,0.45);
}
.pack-credit-glass__ttl{
  font-family:'Orbitron',monospace;font-size:clamp(14px,3.8vw,17px);font-weight:700;
  color:#f8fafc;letter-spacing:0.06em;text-shadow:0 2px 12px rgba(0,0,0,0.5);
}
.pack-credit-glass__sub{
  margin:6px 0 0;font-family:'Rajdhani',sans-serif;font-size:13px;font-weight:600;line-height:1.4;
  color:rgba(226,232,240,0.88);
}
`;

export function injectPackStyles() {
  if (typeof document === 'undefined') return;
  const existing = document.head.querySelector('style[data-global-pack]');
  if (existing) {
    existing.textContent = PACK_CSS;
    return;
  }
  const style = document.createElement('style');
  style.setAttribute('data-global-pack', 'true');
  style.textContent = PACK_CSS;
  document.head.appendChild(style);
}
